"use client";

import { NumericInput } from "@/ui/components/ui/numeric-input";
import { Label } from "@/ui/components/ui/label";

export interface IntervalOption {
	value: number;
	label: string;
}

interface HalfLifeParamsBarProps {
	dose: number;
	onDoseChange: (v: number) => void;
	intervalHours: number;
	onIntervalChange: (v: number) => void;
	intervalOptions: IntervalOption[];
	numDoses: number;
	onNumDosesChange: (v: number) => void;
	labels: {
		dose: string;
		interval: string;
		numDoses: string;
		doseSuffix: string;
	};
}

export function HalfLifeParamsBar({
	dose,
	onDoseChange,
	intervalHours,
	onIntervalChange,
	intervalOptions,
	numDoses,
	onNumDosesChange,
	labels,
}: HalfLifeParamsBarProps) {
	return (
		<div className="grid grid-cols-1 gap-4 rounded-xl border border-border bg-card p-4 sm:grid-cols-3">
			<div className="space-y-1.5">
				<Label htmlFor="hl-dose" className="text-xs uppercase tracking-wide text-muted-foreground">
					{labels.dose}
				</Label>
				<NumericInput
					id="hl-dose"
					value={dose}
					onChange={onDoseChange}
					min={0}
					step={0.05}
					suffix={labels.doseSuffix}
				/>
			</div>

			<div className="space-y-1.5">
				<Label htmlFor="hl-interval" className="text-xs uppercase tracking-wide text-muted-foreground">
					{labels.interval}
				</Label>
				<select
					id="hl-interval"
					value={intervalHours}
					onChange={(e) => onIntervalChange(Number(e.target.value))}
					className="hover:bg-accent/30 focus-visible:ring-ring/50 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50"
				>
					{intervalOptions.map((o) => (
						<option key={o.value} value={o.value}>
							{o.label}
						</option>
					))}
				</select>
			</div>

			<div className="space-y-1.5">
				<Label htmlFor="hl-doses" className="text-xs uppercase tracking-wide text-muted-foreground">
					{labels.numDoses}
				</Label>
				<NumericInput id="hl-doses" value={numDoses} onChange={onNumDosesChange} min={1} max={50} step={1} />
			</div>
		</div>
	);
}
